module.exports = __webpack_public_path__ + "static/media/m1tj64.3e317dbc.png";